export enum LoadType {
  MOUNTED_CEILING_LIGHT = "MOUNTED_CEILING_LIGHT",
  RECESSED_CEILING_LIGHT = "RECESSED_CEILING_LIGHT",
  RECESSED_CEILING_LIGHT_MINI = "RECESSED_CEILING_LIGHT_MINI",
  PENDANT_CEILING_LIGHT = "PENDANT_CEILING_LIGHT",
  KEYLESS_CEILING_LIGHT = "KEYLESS_CEILING_LIGHT",
  MOUNTED_CEILING_LED_LIGHT = "MOUNTED_CEILING_LED_LIGHT",
  FLOURESCENT_CEILING_LIGHT = "FLOURESCENT_CEILING_LIGHT",
  FLOURESCENT_CEILING_LIGHT_1X4 = "FLOURESCENT_CEILING_LIGHT_1X4",
  UNDER_COUNTER_LIGHT = "UNDER_COUNTER_LIGHT",
  TRACK_CEILING_LIGHT = "TRACK_CEILING_LIGHT",
  MOUNTED_WALL_LIGHT = "MOUNTED_WALL_LIGHT",
  FLOOD_LIGHT = "FLOOD_LIGHT",
  OUTLET = "OUTLET",
  OUTLET_240V = "OUTLET_240V",
  OUTLET_220V = "OUTLET_220V",
  OUTLET_120_240V = "OUTLET_120_240V",
  OUTLET_GFCI = "OUTLET_GFCI",
  OUTLET_GFCI_WP = "OUTLET_GFCI_WP",
  OUTLET_FLOOR = "OUTLET_FLOOR",
  OUTLET_HDMI = "OUTLET_HDMI",
  OUTLET_CAT5 = "OUTLET_CAT5",
  CABLE_OUTLET = "CABLE_OUTLET",
  TELEVISION = "TELEVISION",
  TELEPHONE = "TELEPHONE",
  SMOKE_DETECTOR = "SMOKE_DETECTOR",
  CARBON_MONOXIDE_DETECTOR = "CARBON_MONOXIDE_DETECTOR",
  THERMOSTAT = "THERMOSTAT",
  BATH_FAN = "BATH_FAN",
  BATH_FAN_LIGHT = "BATH_FAN_LIGHT",
  DISH_DISPOSAL = "DISH_DISPOSAL",
  DOORBELL_CHIME = "DOORBELL_CHIME",
  GARAGE_DOOR_OPENER = "GARAGE_DOOR_OPENER",
  CEILING_FAN = "CEILING_FAN",
  CEILING_FAN_LIGHT = "CEILING_FAN_LIGHT",
  FAN_PREWIRE = "FAN_PREWIRE",
  HOSE_BIB = "HOSE_BIB",
  FLOOR_TO_FLOOR_TRANSITION = "FLOOR_TO_FLOOR_TRANSITION",
  VIRTUAL_CEILING_FAN_LIGHT = "VIRTUAL_CEILING_FAN_LIGHT",
}

export enum ControllerType {
  SWITCH = "SWITCH",
  SENSOR = "SENSOR",
  OPENER = "OPENER",
}

export enum ControllerSelectionType {
  PRIMARY_ENTRANCE = "PRIMARY_ENTRANCE",
  PRIMARY_ENTRANCE_OUTSIDE_ROOMSET = "PRIMARY_ENTRANCE_OUTSIDE_ROOMSET",
  NEAREST_CANDIDATE = "NEAREST",
  NEAREST_CANDIDATE_OUTSIDE_ROOMSET = "NEAREST_OUTSIDE_ROOMSET",
  NEAREST_DOOR_OUTSIDE_ROOMSET = "NEAREST_DOOR_OUTSIDE_ROOMSET",
  DOOR_BY_ROOM_TYPE = "DOOR_BY_ROOM_TYPE",
  DOOR_BY_ROOM_TYPE_OUTSIDE_ROOMSET = "DOOR_BY_ROOM_TYPE_OUTSIDE_ROOMSET",
  BY_CONTROLLER_TAG = "BY_CONTROLLER_TAG",
  DOOR_BY_ROOM_IDS = "DOOR_BY_ROOM_IDS",
  NEAREST_EXPLICIT_WALL = "EXPLICIT POSITION",
  EXPLICIT_POINT = "EXPLICIT_POINT",
  NONE = "NONE",
}

export enum LoadSymbol {
  NONE = "NONE",
  CIRCLE_4 = "CIRCLE_4",
  CIRCLE_7 = "CIRCLE_7",
  CIRCLE_8 = "CIRCLE_8",
  FRAMED_CIRCLE = "FRAMED_CIRCLE",
  CIRCLE_DL_45_15 = "CIRCLE_DL_45_15",
  CIRCLE_DL_60_40 = "CIRCLE_DL_60_40",
  CIRCLE_DL_12 = "CIRCLE_DL_12",
  RECTANGLE_DL_1X4 = "RECTANGLE_DL_1X4",
  RECTANGLE_DL_2X4 = "RECTANGLE_DL_2X4",
  RECTANGLE_DL_24X4 = "RECTANGLE_DL_24X4",
  CEILING_LIGHT = "CEILING_LIGHT",
  MOUNTED_WALL_LIGHT = "MOUNTED_WALL_LIGHT",
  FLOOD_LIGHT = "FLOOD_LIGHT",
  TRACK_CEILING_LIGHT = "TRACK_CEILING_LIGHT",
  CEILING_FAN = "CEILING_FAN",
  CEILING_FAN_LIGHT = "CEILING_FAN_LIGHT",
  FAN_PREWIRE = "FAN_PREWIRE",
  BATH_FAN = "BATH_FAN",
  BATH_FAN_LIGHT = "BATH_FAN_LIGHT",
  COMMS_TV = "COMMS_TV",
  OUTLET = "OUTLET",
  OUTLET_SINGLE = "OUTLET_SINGLE",
  OUTLET_DUPLEX_2 = "OUTLET_DUPLEX_2",
  OUTLET_SWITCHED = "OUTLET_SWITCHED",
  OUTLET_TRIPLEX = "OUTLET_TRIPLEX",
  OUTLET_QUAD = "OUTLET_QUAD",
  OUTLET_SPECIAL = "OUTLET_SPECIAL",
  HIGH_VOLTAGE_OUTLET = "HIGH_VOLTAGE_OUTLET",
  SQUARE = "SQUARE",
  TEXT_ONLY = "TEXT_ONLY",
  FLOOR_TO_FLOOR_TRANSITION = "FLOOR_TO_FLOOR_TRANSITION",
}

export enum ElectricalBoxType {
  NONE = "NONE",
  ONE_GANG = "ONE_GANG",
  ONE_GANG_WP = "ONE_GANG_WP",
  TWO_GANG = "TWO_GANG",
  THREE_GANG = "THREE_GANG",
  FOUR_GANG = "FOUR_GANG",
  FIVE_GANG = "FIVE_GANG",
  ROUND = "ROUND",
  ROUND_PAN = "ROUND_PAN",
  FAN_RATED = "FAN_RATED",
  FLOOR_SINGLE = "FLOOR_SINGLE",
  FLOOR_DOUBLE = "FLOOR_DOUBLE",
  JUNCTION_BOX = "JUNCTION_BOX",
}
export enum ControllerSwitchType {
  STANDARD = "STANDARD",
  THREE_WAY = "THREE_WAY",
  FOUR_WAY = "FOUR_WAY",
  DIMMER = "DIMMER",
}
